import React from 'react';
import { appConfigStore } from 'Models/AppConfigStore';

import useStore from 'Hooks/useStore';
import { FormattedMessage } from 'react-intl';
import { TicketsTabTrip } from 'Services/Api/_HumanWritten/BookingWizardDataService';
import { BookingWizardData } from 'Views/Components/_HumanWritten/BookingWizard/FerryTripBookingWizard/BookingWizardData/BaseBookingWizardData';
import Icon from 'Views/Components/_HumanWritten/Icon/Icon';
import { RenderAddToWaitListModal } from 'Views/Components/_HumanWritten/Waitlist/AddToWaitListModal';

import { Button, Colors, Display } from 'Views/Components/Button/Button';
import If from 'Views/Components/If/If';

interface WaitlistButtonProps {
	isWaitlisted?: boolean;
	trip: TicketsTabTrip;
	wizardData: BookingWizardData;
	refresh?: () => void;
}

export default function WaitlistButton({ isWaitlisted, trip, wizardData, refresh }: WaitlistButtonProps) {
	const store = useStore();

	if (isWaitlisted) {
		return (
			<p className="waitlisted-text">
				<Icon name="notifications_active" useMaterialIcons />
			</p>
		);
	}

	const waitlistFull = trip.waitlistFull ?? false;

	return (
		<Button
			display={Display.Outline}
			colors={Colors.Secondary}
			className="add-to-waitlist__button"
			onClick={() =>
				RenderAddToWaitListModal(
					trip.id,
					trip.vehicleSpacesTotal > 0,
					wizardData,
					!store.isStaff ? store.userId : undefined,
					!store.isStaff ? store.email : '',
					refresh,
					false,
					appConfigStore.passengerOnlyBookingEnabled && trip.walkOnBookingsDisabled !== true,
				)
			}
			disabled={waitlistFull}
		>
			{/*
				A bell with a plus offers to add you; a full list cannot, and the button is disabled.
				Crossing the bell out says that at a glance — the `(full)` beside the label is easy
				to miss next to an icon still inviting the press.
			*/}
			<Icon name={waitlistFull ? 'notifications_off' : 'notification_add'} useMaterialIcons />
			{/*
				One element, not three. The label and its `(full)` were bare text nodes, which a flex
				container makes into separate anonymous items — so the button's gap opened up between
				`Notify me` and `(full)` and the pair sat off-centre against the bell.
			*/}
			<span className="add-to-waitlist__label">
				<FormattedMessage id="add-to-waitlist__action-name" defaultMessage="Notify me" />
				<If condition={waitlistFull}>
					{' '}
					<FormattedMessage id="add-to-waitlist__list-full__label" defaultMessage="(full)" />
				</If>
			</span>
		</Button>
	);
}
